const COMPARISON = {
  EQUAL: 0,
  STRICT_EQUAL: 1,
  NOT_EQUAL: 2,
  STRICT_NOT_EQUAL: 3,
  GREATER_THAN: 4,
  GREATER_THAN_EQUAL: 5,
  LESS_THAN: 6,
  LESS_THAN_EQUAL: 7,
}

export default COMPARISON
